import { Create, SimpleForm } from "react-admin";
import BackButtonToolbar from "features/BackButtonToolbar";
import InactiveDeleteOptionEditToolbar from "features/EditToolbar";
import SaveForm from "./SaveForm";

const CreateAccommodationOrder = () => (
  <Create
    title="Създаване на настанителна заповед"
    redirect="list"
    actions={<BackButtonToolbar />}
  >
    <SimpleForm toolbar={<InactiveDeleteOptionEditToolbar />}>
      <SaveForm />
    </SimpleForm>
  </Create>
);

export default CreateAccommodationOrder;
